export default __webpack_public_path__ + "static/media/Batat.a8b0b588.png";